import React from 'react';
import { Button } from 'antd';
import theme from '@/assets/theme';

const MICROSOFT_THEME_TYPES = new Set([22, 24]);

function buildMicrosoftInitiateUrl(returnTo: string): string {
  const configuredBase = process.env.REACT_APP_BASE_URL?.trim();
  if (!configuredBase) {
    return `/api/auth/microsoft/initiate/?return_to=${returnTo}`;
  }
  const base = configuredBase.replace(/\/+$/, '');
  return `${base}/api/auth/microsoft/initiate/?return_to=${returnTo}`;
}

const MicrosoftLoginButton: React.FC = () => {
  if (!MICROSOFT_THEME_TYPES.has(theme.themeType)) return null;

  const handleLogin = () => {
    localStorage.removeItem('@token');
    localStorage.removeItem('@refreshToken');
    localStorage.removeItem('persist:root');
    const returnTo = encodeURIComponent(window.location.origin);
    const initiateUrl = buildMicrosoftInitiateUrl(returnTo);
    window.location.href = initiateUrl;
  };

  return (
    <Button
      onClick={handleLogin}
      data-testid='microsoft-login-button'
      style={{
        width: '100%',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        border: '1px solid #d9d9d9',
        borderRadius: '8px',
        backgroundColor: 'var(--surface-container)',
        color: '#242424',
        fontWeight: 500,
        fontSize: '14px',
      }}
      block
    >
      Sign in with Microsoft
    </Button>
  );
};

export default MicrosoftLoginButton;
